import { User } from "@/types/types";
import { getSubscriptionPlan } from "@/utils/subscriptionLevels/getSubscriptionPlan";

export const isHighestPlan = (
  stripeSubscriptionId: User["stripeSubscriptionId"]
): boolean => {
  const subscriptionPlan = getSubscriptionPlan(stripeSubscriptionId);

  return subscriptionPlan === "third";
};
